import { HttpParams } from "@angular/common/http";

export function buildQueryParam(params: any): HttpParams {
    
    let httpParams = new HttpParams();

    for (const key in params) {
      if (
        params.hasOwnProperty(key)
        && params[key] != null
        && params[key] != undefined
        && !Number.isNaN(params[key])
      ) {
        httpParams = httpParams.set(key, params[key]);
      }
    }

    return httpParams;
}
